<template>
  <div class="responsive-navbar-container">
    <div class="responsive-navbar" v-if="visible">
      <div v-for="(item, index) in navItems" :key="index">
        <router-link :to="item.url" @click.native="hideMenu">{{ $t(`HEADER.${item.name}`) }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    navItems: Array
  },
  methods: {
    hideMenu () {
      this.$emit('hideMenu')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Header/ResponsiveNav.vue